import { render, staticRenderFns } from "./ClubGradeList.vue?vue&type=template&id=610e5e62&"
import script from "./ClubGradeList.vue?vue&type=script&lang=js&"
export * from "./ClubGradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports